"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeightAndWidthToTileSizeName = exports.isLargeWideFrame = exports.getFrameWidth = exports.isAIGenPhoto = exports.isArtPhoto = exports.isCenterpiece = exports.isCollage = exports.isPhoto = exports.getTileSKU = exports.extractTilePropertiesFromSKU = exports.getFrameFromSKU = exports.createSKU = exports.tileSizeToSKUSize = exports.getSupportedTileDesignerSplitStyles = exports.isXL = exports.tileSizeToOrientation = exports.getTileFilter = void 0;
const matting_1 = require("../consts/matting");
const artConsts_1 = require("../consts/artConsts");
const tiles_1 = require("../consts/tiles");
const frames_1 = require("../consts/frames");
const filters_1 = require("../consts/filters");
const matting_2 = require("./matting");
const PLASTIC_FRAME_WIDTH = 0.345; // In inches
const MDF_FRAME_WIDTH = 0.47; // Frame is 12mm = 0.47 inches
const EQUAL_FILTER_ID = 'equal';
function getTileFilter({ tileSize, frameColor, matting, mattingColor }) {
    const photoOrientation = (0, exports.tileSizeToOrientation)(tileSize);
    let tileFilterId;
    if ([matting_1.MATTING.DEEP, matting_1.MATTING.ULTRA_DEEP].includes(matting)) {
        tileFilterId = [tiles_1.TILE_SIZES.RECTANGLE_22X44, tiles_1.TILE_SIZES.RECTANGLE_44X22].includes(tileSize)
            ? EQUAL_FILTER_ID
            : matting_1.MATTING.DEEP;
    }
    else if (matting === matting_1.MATTING.TOP) {
        tileFilterId = matting_1.MATTING.TOP;
    }
    else if (matting === matting_1.MATTING.ROUND) {
        tileFilterId = matting_1.MATTING.ROUND;
    }
    else if (matting === matting_1.MATTING.HEART) {
        tileFilterId = matting_1.MATTING.HEART;
    }
    else if (matting === matting_1.MATTING.SHALLOW || matting === matting_1.MATTING.MEDIUM) {
        tileFilterId = EQUAL_FILTER_ID;
    }
    else {
        tileFilterId = 'dynamic_backend';
    }
    const mattingSize = (0, matting_2.getBorderWidthForMatting)(matting, photoOrientation, tileSize) || 0;
    return {
        id: tileFilterId,
        matting: {
            size: mattingSize,
            color: mattingColor || 'WHITE',
            colorName: getKeyByValue(matting_1.MAT_COLORS, mattingColor),
        },
        frame: {
            color: frameColor,
        },
        imageEffect: {
            name: 'original',
        },
    };
}
exports.getTileFilter = getTileFilter;
function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
}
const tileSizeToOrientation = (tileSize) => {
    const dimensions = tiles_1.TILESIZES_TO_INCHES[tileSize];
    if (!dimensions) {
        return null;
    }
    const aspectRatio = dimensions.width / dimensions.height;
    if (aspectRatio > 1) {
        return artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE;
    }
    else if (aspectRatio < 1) {
        return artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT;
    }
    else {
        return artConsts_1.PHOTO_ORIENTATIONS.SQUARE;
    }
};
exports.tileSizeToOrientation = tileSizeToOrientation;
function isXL(tileSize) {
    return [tiles_1.TILE_SIZES.RECTANGLE_27X36, tiles_1.TILE_SIZES.RECTANGLE_36X27].includes(tileSize);
}
exports.isXL = isXL;
function getSupportedTileDesignerSplitStyles({ tileSizes, includeNewFilters = true }) {
    let supportedFrameColors;
    if (tileSizes.some((size) => size === tiles_1.TILE_SIZES.SQUARE_4X4)) {
        supportedFrameColors = [frames_1.FRAME_COLORS.NONE];
    }
    else if (tileSizes.some((size) => isXL(size))) {
        supportedFrameColors = [frames_1.FRAME_COLORS.BLACK, frames_1.FRAME_COLORS.WHITE, frames_1.FRAME_COLORS.NONE];
    }
    else if (tileSizes.some((tileSize) => tileSize === tiles_1.TILE_SIZES.SQUARE_8X8)) {
        supportedFrameColors = [frames_1.FRAME_COLORS.BLACK, frames_1.FRAME_COLORS.WHITE, frames_1.FRAME_COLORS.NONE];
    }
    else {
        supportedFrameColors = [frames_1.FRAME_COLORS.BLACK, frames_1.FRAME_COLORS.WHITE, frames_1.FRAME_COLORS.WOOD, frames_1.FRAME_COLORS.NONE];
    }
    const supportedFilters = [filters_1.FILTERS.NONE, filters_1.FILTERS.NOIR, filters_1.FILTERS.SILVER];
    const supportedMatting = matting_1.SUPPORTED_MATTING;
    if (includeNewFilters) {
        supportedFilters.push(filters_1.FILTERS.DRAMATIC, filters_1.FILTERS.VIVID, filters_1.FILTERS.WINTER);
    }
    return { supportedFrameColors, supportedFilters, supportedMatting };
}
exports.getSupportedTileDesignerSplitStyles = getSupportedTileDesignerSplitStyles;
// Convert tileSize format to SKU format - e.g. RECTANGLE_8X11 -> 8x11
// Note: it also converts landscape orientations to portrait - e.g. RECTANGLE_11X8 -> 8x11
function tileSizeToSKUSize(tileSize) {
    const normalizedTileSize = (0, exports.tileSizeToOrientation)(tileSize) === artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE ? tiles_1.TILE_SIZES_ROTATION[tileSize] : tileSize;
    // Patch because 25X8 doesn't have a flipped orientation
    if (normalizedTileSize === tiles_1.TILE_SIZES.RECTANGLE_25X8) {
        return '8x25';
    }
    else {
        return normalizedTileSize.split('_')[1].toLowerCase();
    }
}
exports.tileSizeToSKUSize = tileSizeToSKUSize;
function createSKU({ materialType, color, size }) {
    return `${materialType}${tiles_1.SKU_SEPARATOR}${color}${tiles_1.SKU_SEPARATOR}${size}`;
}
exports.createSKU = createSKU;
function getFrameFromSKU(sku) {
    const skuParts = sku.split(tiles_1.SKU_SEPARATOR);
    if (skuParts.length < 3) {
        return undefined;
    }
    const [materialType, color, size] = skuParts;
    return { color, size, materialType };
}
exports.getFrameFromSKU = getFrameFromSKU;
function extractTilePropertiesFromSKU(tileSKU) {
    const [tileSize, materialType, frameColor] = tileSKU.split('-', 3);
    const pricingProduct = {
        tileSize: tileSize,
        materialType: (materialType || tiles_1.MATERIAL_TYPES.CLASSIC),
    };
    if (frameColor) {
        pricingProduct.frameColor = frameColor;
    }
    return pricingProduct;
}
exports.extractTilePropertiesFromSKU = extractTilePropertiesFromSKU;
// deprecated
function getTileSKU({ tileSize, materialType }) {
    if (materialType && ![tiles_1.MATERIAL_TYPES.CLASSIC, tiles_1.MATERIAL_TYPES.FRAMELESS].includes(materialType)) {
        return `${tileSize}-${materialType}`;
    }
    return tileSize;
}
exports.getTileSKU = getTileSKU;
function isPhoto(tile) {
    return tile && tile.tileContent === tiles_1.TILE_CONTENT.PHOTO;
}
exports.isPhoto = isPhoto;
function isCollage(tile) {
    return tile && tile.tileContent === tiles_1.TILE_CONTENT.COLLAGE;
}
exports.isCollage = isCollage;
function isCenterpiece(tile) {
    return (tile && tile.tileContent === tiles_1.TILE_CONTENT.CENTERPIECE) || (tile === null || tile === void 0 ? void 0 : tile.tileSize) === tiles_1.TILE_SIZES.RECTANGLE_25X8;
}
exports.isCenterpiece = isCenterpiece;
function isArtPhoto(tile) {
    return tile && tile.tileContent === tiles_1.TILE_CONTENT.ART_PHOTO;
}
exports.isArtPhoto = isArtPhoto;
function isAIGenPhoto(tile) {
    return tile && tile.tileContent === tiles_1.TILE_CONTENT.AI_GEN_PHOTO;
}
exports.isAIGenPhoto = isAIGenPhoto;
// Return the width of the frame (MDF only)
function getFrameWidth({ materialType, tileSize, isPlastic, }) {
    if (materialType === tiles_1.MATERIAL_TYPES.CLASSIC) {
        return isPlastic ? PLASTIC_FRAME_WIDTH : MDF_FRAME_WIDTH;
    }
    else if (materialType === tiles_1.MATERIAL_TYPES.WIDE_FRAME) {
        // The wide frame contain two different widths (above 12x16 it is wider)
        if (!isLargeWideFrame(tileSize)) {
            return 1.02; // Frame is 26mm = 1.02 inches
        }
        else {
            return 1.34; // Frame is 34mm = 1.34 inches
        }
    }
    else {
        return 0;
    }
}
exports.getFrameWidth = getFrameWidth;
function isLargeWideFrame(tileSize) {
    const dimensions = tiles_1.TILESIZES_TO_INCHES[tileSize];
    return dimensions.width * dimensions.height >= 400;
}
exports.isLargeWideFrame = isLargeWideFrame;
const getHeightAndWidthToTileSizeName = () => {
    const result = {};
    for (const sizeName of Object.keys(tiles_1.TILESIZES_TO_INCHES)) {
        const size = tiles_1.TILESIZES_TO_INCHES[sizeName];
        const heightAndWidth = [Math.floor(size.width), Math.floor(size.height)].join('x');
        result[heightAndWidth] = sizeName;
    }
    return result;
};
exports.getHeightAndWidthToTileSizeName = getHeightAndWidthToTileSizeName;
//# sourceMappingURL=tiles.js.map